export const tooltipSimpleSearch: Record<string, string> = {
    'identiteter': 'GidID, Navn, Kode, E-postadresser',
    'tilgangskoder': 'Beskrivelse, Tilgangskode',
    'admenheter': 'Enhetsnavn, Id, Enhetsforkortelse',
    'brukere': 'navn, gidID, Kode, Administrativ enhet',
    'kurver': 'Navn, Beskrivelse, Kode',
    'tilleggsdata': 'Id, Beskrivelse, Sakstype, Journalkategori, Partsforhold, Datafelt'
};